<template>
  <TextInput
    v-model="model"
    v-bind="$attrs"
    v-on="listeners"
    inputmode="numeric"
    :maxlength="maxLength"
    @keypress="onKeypress"
  />
</template>

<script>
  import { getFormattedNumber } from 'src/utils/translation.js';

  import TextInput from 'src/components/form/TextInput/TextInput.vue';

  const removeSpaces = string => string.replace(/\s/g, '');

  export default {
    name: 'NumberInput',
    components: { TextInput },
    props: {
      value: Number,
      maxLength: Number,
    },
    emits: ['input'],
    methods: {
      onKeypress(event) {
        const { key } = event;
        const { value } = event.target;
        const numberValue = Number(removeSpaces(value + key));
        if (key === '.') {
          if (value.indexOf('.') > 0) {
            event.preventDefault();
          }
        } else if (this.isInvalidNumber(numberValue)) {
          event.preventDefault();
        }
      },
      isInvalidNumber(n) {
        return Number.isNaN(n) || !Number.isFinite(n) || n >= Number.MAX_SAFE_INTEGER;
      }
    },
    computed: {
      model: {
        get() {
          if (!this.value) return this.value;
          return String(getFormattedNumber(this.value));
        },
        set(value) {
          const numberValue = parseFloat(removeSpaces(value));
          const emitValue = Number.isNaN(numberValue) ? null : numberValue;
          this.$emit('input', emitValue);
        },
      },
      listeners() {
        const { input, ...rest } = this.$listeners;

        return rest;
      },
    },
  }
</script>